export default "__VITE_ASSET__D0z1HdqR__"